// extracted by mini-css-extract-plugin
module.exports =  {"link":"Link__link--ZK","conservative":"Link__conservative--M2"};